const groupCaptions = (captionsObj, numOfCaptions) => {
  let captionGroups = [];
  let captionsPerPlatforms = {};

  captionsObj?.forEach((caption) => {
    // Google Business Profile dropdown name is recognized as GMB in our system
    if (caption.platform === "Google Business Profile") {
      caption.platform = "GMB";
    }

    if (captionsPerPlatforms[caption.platform]) {
      captionsPerPlatforms[caption.platform].push({caption: caption.caption, id: caption.id});
    } else {
      captionsPerPlatforms[caption.platform] = [{caption: caption.caption, id: caption.id}];
    }
  });

  let captionKeys = Object.keys(captionsPerPlatforms);
  let captionVals = Object.values(captionsPerPlatforms);

  for (let i = 0; i < numOfCaptions; i++) {
    let group = {
      selected: false,
      id: i,
      captions: [],
    };

    captionVals.forEach((cap, index) => {
      group.captions.push({
        text: cap[i].caption,
        id: cap[i].id,
        platform: captionKeys[index],
      });
    });

    captionGroups.push(group);
  }

  return captionGroups;
};

export default groupCaptions;
